import { render, staticRenderFns } from "./Indemnity.vue?vue&type=template&id=9618b5da&scoped=true"
import script from "./Indemnity.vue?vue&type=script&lang=js"
export * from "./Indemnity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9618b5da",
  null
  
)

export default component.exports